import { computed, Directive, input } from '@angular/core';

type ButtonSize = 'S' | 'M' | 'L';

export const enum FilledFlavor {
	BASIC = 'BASIC',
	PRIMARY = 'PRIMARY',
	WARNING = 'WARNING',
}

const BUTTON_CLASS_BY_SIZE: Record<ButtonSize, string> = {
	S: 'p-1h-rl p-0t-tb br-1 fl-gap-0t',
	M: 'p-2-rl p-1-tb br-1 fl-gap-1',
	L: 'p-3-rl p-1-tb br-1 fl-gap-1',
};

@Directive({
	selector: '[buttonFilled]',
	standalone: true,
	host: {
		class: 'fl fl-ai-c fl-jc-c fs-m fc-white',
		'[class.bg-270]': '!$disabled() && $flavorIsBasic()',
		'[class.bg-standard-hover-over-270-on-hover]': '!$disabled() && $flavorIsBasic()',
		'[class.bg-primary-500]': '!$disabled() && $flavorIsPrimary()',
		'[class.bg-primary-700-on-hover]': '!$disabled() && $flavorIsPrimary()',
		'[class.bg-warn-500]': '!$disabled() && $flavorIsWarning()',
		'[class.bg-warn-700-on-hover]': '!$disabled() && $flavorIsWarning()',
		'[class.fc-200-as-bg]': '$disabled()',
		'[class]': '$sizeClasses()',
		'[attr.disabled]': '$disabled() ? "true" : null',
		style: '--spacing: 8px; transition: background-color 300ms, color 300ms;',
	},
})
export class ButtonFilledDirective {
	public readonly $flavor = input<FilledFlavor | `${FilledFlavor}`>(FilledFlavor.PRIMARY, {
		alias: 'flavor',
	});

	public readonly $size = input<ButtonSize>('M', { alias: 'size' });

	public readonly $disabled = input<boolean, boolean | 'true' | 'false'>(false, {
		alias: 'disabled',
		transform: (value) => {
			return `${value}` === `true`;
		},
	});

	protected readonly $sizeClasses = computed(() => {
		const size = this.$size();
		return BUTTON_CLASS_BY_SIZE[size] ?? '';
	});

	protected readonly $flavorIsBasic = computed(() => {
		return this.$flavor() === FilledFlavor.BASIC;
	});

	protected readonly $flavorIsPrimary = computed(() => {
		return this.$flavor() === FilledFlavor.PRIMARY;
	});

	protected readonly $flavorIsWarning = computed(() => {
		return this.$flavor() === FilledFlavor.WARNING;
	});
}
